import getScreenSize from './ScreenSizeHelper'

const isBrowser = typeof window !== 'undefined'

const viewPorts = ['xs', 'sm', 'md', 'lg', 'xl']

const viewPortSize = () => {
  return getScreenSize()
}

const is = (size) => {
  if (viewPorts.indexOf(size) === -1) { return false }
  return viewPortSize() === size
}

const isEqualOrGreaterThan = (size) => {
  if (viewPorts.indexOf(size) === -1) { return false }
  return viewPorts.indexOf(viewPortSize()) >= viewPorts.indexOf(size)
}

const isIpad = () => {
  return isBrowser ? (navigator.userAgent.match(/iPad/i) != null) : false
}

const isVisibleInViewport = (element) => {
  if (!element) return null

  const rect = element.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  if (rect.top >= windowHeight) {
    return 0
  }
  if (rect.top <= 0) {
    const visible = Math.max(rect.top + element.offsetHeight, 0)
    return Math.min(visible, windowHeight)
  }
  return Math.min(windowHeight - rect.top, element.offsetHeight)
}

export default {
  is,
  isEqualOrGreaterThan,
  isIpad,
  isVisibleInViewport
}
